/**
 * ScrollToTop - Scrolls to top on navigation
 * 
 * Automatically scrolls to top when navigating to a new page,
 * with exclusions for specific routes where scroll position should be preserved.
 */
import React from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

function ScrollToTop() {
  const location = useLocation();
  const navigationType = useNavigationType();

  React.useEffect(() => {
    // Don't auto-scroll to top on pricing page to preserve user's scroll position
    const excludedPaths = ['/app/account/pricing', '/app/pricing', '/account/pricing'];
    const shouldSkipScroll = excludedPaths.includes(location.pathname);
    
    if (navigationType === 'PUSH' && !shouldSkipScroll) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location, navigationType]);

  return null;
}

export default ScrollToTop;

